import get from 'lodash.get'
import { normalizeFieldConfig, resolveFieldValue, findEdgeLabelConfig, resolveNodeType } from './fieldHelpers'

function buildPathKey (ancestorIds, levelId, entityId) {
  return [...ancestorIds, `${levelId}-${entityId}`].join('/')
}

export function buildFromHierarchy (items, levels, edgeLabels) {
  if (!items.length || !levels.length) return { nodes: [], edges: [] }

  const nodeMap = new Map()
  const edgeMap = new Map()

  items.forEach(row => {
    const ancestorIds = []

    levels.forEach((level, levelIndex) => {
      if (!level.idAccessor) {
        console.warn(`[FlowGraph] Level "${level.id}" is missing idAccessor — skipping`)
        return
      }
      const entityId = get(row, level.idAccessor)
      if (entityId == null) return

      const entityKey = String(entityId)
      const pathKey = buildPathKey(ancestorIds, level.id, entityKey)

      if (!nodeMap.has(pathKey)) {
        const nameConfig = normalizeFieldConfig(level.name)
        const descConfig = normalizeFieldConfig(level.description)

        nodeMap.set(pathKey, {
          id: pathKey,
          type: resolveNodeType(level.nodeType),
          position: { x: 0, y: 0 },
          data: {
            nameConfig,
            descriptionConfig: descConfig,
            nameValue: resolveFieldValue(row, nameConfig),
            descriptionValue: resolveFieldValue(row, descConfig),
            variant: level.variant || 'default',
            color: level.color || undefined,
            size: level.size || 'md',
            levelId: level.id,
            levelIndex,
            raw: row
          }
        })
      }

      if (levelIndex > 0 && ancestorIds.length > 0) {
        const parentPathKey = ancestorIds[ancestorIds.length - 1]
        const edgeKey = `${parentPathKey}->${pathKey}`

        if (!edgeMap.has(edgeKey)) {
          const parentLevel = levels[levelIndex - 1]
          const labelConfig = findEdgeLabelConfig(edgeLabels, parentLevel.id, level.id)

          const edge = {
            id: `e-${edgeKey}`,
            source: parentPathKey,
            target: pathKey
          }

          if (labelConfig) {
            const rawLabel = get(row, labelConfig.accessor)
            if (rawLabel != null) {
              edge.label = rawLabel
              edge.data = { label: rawLabel, format: labelConfig.format }
              edge.type = 'labeled'
            }
          }

          edgeMap.set(edgeKey, edge)
        }
      }

      ancestorIds.push(pathKey)
    })
  })

  return {
    nodes: Array.from(nodeMap.values()),
    edges: Array.from(edgeMap.values())
  }
}
